<template>
  <v-select
    v-bind="$attrs"
    :value="value"
    outlined
    color="brandPrimary"
    hide-details="auto"
    persistent-hint
    :label="label"
    :hint="hint"
    :items="items"
    :clearable="!required"
    :rules="rules"
    @input="$emit('input', $event)"
  >
    <template #item="{ item }">
      <div class="metric-option">
        <span class="metric-option__text">{{ item.text }}</span>
        <StatusChip v-if="item.type" small :text="item.type" class="metric-option__chip" />
        <StatusChip v-if="item.isEngageData" small text="Engage Data" class="metric-option__chip" />
      </div>
    </template>

    <template #selection="{ item }">
      <div class="metric-option">
        <span class="metric-option__text">{{ item.text }}</span>
        <StatusChip v-if="item.type" small :text="item.type" class="metric-option__chip" />
        <StatusChip v-if="item.isEngageData" small text="Engage Data" class="metric-option__chip" />
      </div>
    </template>
  </v-select>
</template>

<script>
import StatusChip from "@/components/generic/StatusChip.vue";

export default {
  name: "MetricSelect",
  components: { StatusChip },
  inheritAttrs: false,
  props: {
    value: { type: [String, Number], default: null },
    label: { type: String, required: true },
    hint: { type: String, default: "" },
    items: { type: Array, required: true },
    required: { type: Boolean, default: false },
  },
  emits: ["input"],
  computed: {
    rules() {
      if (!this.required) return [];
      const field = this.label.replace(/\*$/, "");
      return [(v) => (v !== null && v !== undefined && v !== "") || `${field} is required`];
    },
  },
};
</script>

<style scoped>
.metric-option {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.metric-option__text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.metric-option__chip {
  flex-shrink: 0;
}
</style>
